import React from 'react';
import { useParams } from 'react-router-dom';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import CapacidadFuncional from '../components/CapacidadFuncional';

export default function CreateCapacidadFuncionalPage() {
  const { idPaciente } = useParams();

  return (
    <DashboardLayout>
      <CapacidadFuncional idPaciente={idPaciente} />
    </DashboardLayout>
  );
}
